import { useEffect } from 'react';
import { BaseSpin } from '@components';
import NoDataServerError from '@components/empty-state';
import { useAppDispatch, useAppSelector } from '@hooks/reduxHooks.ts';
import { LearningStatistics } from '@routes/sidebar/___shared___/components/learning-statistics';
import { LEARNING_STATISTICS_MODE } from '@routes/sidebar/___shared___/components/learning-statistics/constants.ts';
import { getStatistics } from '@routes/sidebar/___shared___/model/statistics.slice.ts';
import { DashboardWrapper } from '@routes/sidebar/learning/ui/dashboard-tab/dashboard/styled.ts';
import { GamificationSection } from '@routes/sidebar/learning/ui/dashboard-tab/gamification-section';
import { LearningCompliance } from '@routes/sidebar/learning/ui/dashboard-tab/learning-compliance';

export const Dashboard = () => {
    const dispatch = useAppDispatch();
    const learnerStatisticsSummary = useAppSelector((state) => state.statistics.statisticsSummary);
    const isGetStatisticsPending = useAppSelector((state) => state.statistics.isGetStatisticsPending);

    useEffect(() => {
        void dispatch(getStatistics());
    }, [dispatch]);

    if (isGetStatisticsPending) return <BaseSpin size="medium" />;
    if (!learnerStatisticsSummary) return <NoDataServerError />;

    return (
        <DashboardWrapper>
            <GamificationSection />
            <LearningCompliance />
            <LearningStatistics
                options={{
                    mode: LEARNING_STATISTICS_MODE.LEARNER,
                    learnerStatisticsSummary,
                }}
            />
        </DashboardWrapper>
    );
};
